module.exports = __webpack_public_path__ + "img/terroir-inspect-portrait.34ac7f45.jpg";